let loadTrigger = document.getElementById('js-car');
if (loadTrigger) {

    let isLoading = false;
    document.addEventListener('scroll', function(event) {
        let viewHeight = document.documentElement.clientHeight;
        if (!isLoading && loadTrigger.getBoundingClientRect().bottom < viewHeight) {
            loadTrigger.classList.add('run')
            isLoading = true;
        }
    });
}
let floorTooltip = document.querySelector('.js-floor-tooltip');
let floorTooltipNumber = document.querySelector('.js-floor-tooltip-number');
let floorTooltipFree = document.querySelector('.js-floor-tooltip-free');
let body = document.body;
let docEl = document.documentElement;

function setImagePosition() {
    let imgElement = document.querySelector('.js-first-screen__image');
    if (imgElement) {
        let imgWrapperElement = document.querySelector('.js-first-screen__image__wrapper');
        let width = imgElement.getBoundingClientRect().width - imgWrapperElement.getBoundingClientRect().width;
        if (width > 0) {
            let left = (-1 * parseInt(width / 2)) + 'px';
            imgElement.style.left = left;
            let houseElement = document.querySelector('.js-house__svg');
            houseElement.style.left = left;
        }
    }
}

function setFloorImageSize() {
    let imgElement = document.querySelector('.js-floor__img');

    if (imgElement) {

        let src = imgElement.src;

        let newImg = new Image();

        newImg.onload = function() {
            let svgElement = document.querySelector('.js-floor__svg');
            let height = newImg.height;
            let width = newImg.width;
            console.log(width);
            svgElement.setAttribute('width', width + 'px');
            svgElement.setAttribute('height', height + 'px');
            svgElement.setAttribute('viewBox', '0 0 ' + width + ' ' + height);
        }
        newImg.src = src;
        console.log(newImg);
    }
}
document.addEventListener("DOMContentLoaded", function() {
    setImagePosition();
    setFloorImageSize();
});
window.addEventListener('resize', function() {
    setImagePosition();
    setFloorImageSize();
});
window.showFloor = function(el) {
    let scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
    let b = el.getBoundingClientRect();
    floorTooltipNumber.innerHTML = el.dataset.number;
    floorTooltipFree.innerHTML = el.dataset.free;
    let top = scrollTop + (b.top + b.top + b.height) / 2 - 20;
    let left = el.getBoundingClientRect().left + el.getBoundingClientRect().width + 15;
    if (el.dataset.house == 2) {
        left = el.getBoundingClientRect().left - 270;
    }
    let sidebar = document.querySelector('.aside');
    if (sidebar) {
        left = left - sidebar.getBoundingClientRect().width
    }

    floorTooltip.style.top = top + 'px';
    floorTooltip.style.left = left + 'px';
    floorTooltip.classList.remove('d-none');
    el.classList.remove('-is-hide');
}
window.hideFloor = function(el) {
    el.classList.add('-is-hide');
    floorTooltip.classList.add('d-none');
}
